import React from "react";

const Card = ({ children }) => (
  <div className="bordered rounded shadowed bg-white">{children}</div>
);

export default Card;



// WEBPACK FOOTER //
// ./components/Card.jsx